import { FC, useMemo, useState } from "react";
import { Competency } from "../../../../src/types/staffer";
import { ReactComponent as VerifiedUserIcon } from "../../img/VerifiedUserIcon.svg";
import styles from "./CompetencyView.module.css";
import clsx from "clsx";
import Button from "../mui/redesignedComponents/Button";
import { Modal } from "@material-ui/core";
import { IconButton } from '@material-ui/core'
import { CloseRounded } from '@material-ui/icons'

type Props = {
  competencies: Competency[]
}

const PAGE_SIZE = 7

const CompetencyView: FC<Props> = ({ competencies: unsortedCompetencies }) => {
  const [isOpen, setIsOpen] = useState(false)
  const competencies = useMemo(() => unsortedCompetencies.sort((a, b) => {
    if (a.approvedByBusinesses.length > b.approvedByBusinesses.length) {
      return -1
    } else if (a.approvedByBusinesses.length < b.approvedByBusinesses.length) {
      return 1
    } else {
      return a.jobType.localeCompare(b.jobType)
    }
  }), [unsortedCompetencies])

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <span className={styles.title}>Competencies</span>
        <div className={styles.countContainer}>
          <span className={styles.count}>{competencies.length}</span>
        </div>
      </div>
      <div className={styles.competencyList}> 
        {competencies.map((c, index) => (
          index < PAGE_SIZE && (
            <div className={styles.listItem} key={index}>
              <div className={clsx(styles.listItemSection, c.approvedByBusinesses.length > 0 && styles.divider)}>
                <div className={styles.listItemSectionCol}>
                <span className={styles.skill}>
                  {c.skill}
                </span>
                <span className={styles.jobType}>
                  {c.jobType}
                </span>
              </div>
            </div>
            {c.approvedByBusinesses.length > 0 && (
              <div className={styles.listItemSection}>
                <VerifiedUserIcon style={{ width: 18, height: 18 }} />
                <span className={styles.verified}>
                  Verified by {c.approvedByBusinesses.map((b) => b.name).join(', ')}
                </span>
              </div>
            )}
          </div>
        )))}
        {competencies.length > PAGE_SIZE && (
          <Button variant="outlined" color="primary" onClick={() => setIsOpen(true)}>
            Show more
          </Button>
        )}
      </div>
      <Modal open={isOpen} onClose={() => setIsOpen(false)} className={styles.modal}>
        <div className={styles.modalContent}>
          <div className={styles.modalHeader}>
            <span className={styles.title}>Competencies</span>
            <IconButton onClick={() => setIsOpen(false)} className={styles.closeBtn}>
              <CloseRounded />
            </IconButton>
          </div>
          <div className={styles.modalCompetencyList}> 
            {competencies.map((c, index) => (
                <div className={styles.listItem} key={index}>
                  <div className={clsx(styles.listItemSection, c.approvedByBusinesses.length > 0 && styles.divider)}>
                    <div className={styles.listItemSectionCol}>
                    <span className={styles.skill}>
                      {c.skill}
                    </span>
                    <span className={styles.jobType}>
                      {c.jobType}
                    </span>
                  </div>
                </div>
                {c.approvedByBusinesses.length > 0 && (
                  <div className={styles.listItemSection}>
                    <VerifiedUserIcon style={{ width: 18, height: 18 }} />
                    <span className={styles.verified}>
                      Verified by {c.approvedByBusinesses.map((b) => b.name).join(', ')}
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default CompetencyView